var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('carousel',{attrs:{"responsive":{
                0: {
                    items: 1,
                    nav: false,
                    mouseDrag: false,
                    stagePadding: 100,
                    loop: true,
                    margin: 15,
                    autoplay: true
                },
                600: {
                    items: 3,
                    nav: false,
                    mouseDrag: false,
                    stagePadding: 100,
                    loop: true,
                    margin: 15,
                    autoplay: true
                },
                800: {
                    items: 4,
                    nav: false,
                    mouseDrag: false,
                    stagePadding: 100,
                    loop: true,
                    margin: 15,
                    autoplay: true
                }
            }}},_vm._l((_vm.realstates),function(realstate,i){return _c('div',{key:i,staticClass:"col-12 p-3 my-1"},[_c('img',{staticClass:"img-logo",attrs:{"src":realstate.logo,"alt":""}})])}),0)],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-11 mx-auto text-center"},[_c('h2',{staticClass:"text-primary font-weight-bold mb-2"},[_vm._v("\n            Han confiado en nosotros\n        ")])])
}]

export { render, staticRenderFns }